import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ecd910f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selected-option" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "dropdown-options"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "custom-select mr-4",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.selectedCountry)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.selectedCountry.flag,
            alt: _ctx.selectedCountry.name,
            class: "flag-icon"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.selectedCountry)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.selectedCountry.prefix), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isDropdownOpen)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesArray, (country) => {
            return (_openBlock(), _createElementBlock("li", {
              key: country.code,
              onClick: _withModifiers(($event: any) => (_ctx.selectCountry(country)), ["stop"])
            }, [
              _createElementVNode("img", {
                src: country.flag,
                alt: country.name,
                class: "flag-icon"
              }, null, 8, _hoisted_6),
              _createElementVNode("span", null, _toDisplayString(country.prefix), 1)
            ], 8, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}